export default "__VITE_ASSET__D9458S21__"